import {
  ArrowsDownUp,
  Bank,
  ChartLineUp,
  MoneyWavy,
  TrendUp,
} from "@phosphor-icons/react"
import { type MetricConfiguration } from "@tokenterminal/tt-analytics-api-types/dist/api/metrics"
import type { ElementType } from "react"

export const getMetricIcon = (metric: MetricConfiguration): ElementType => {
  try {
    const {
      categories: [mainCategory],
      is_gmv_metric,
    } = metric
    switch (mainCategory) {
      case "alternative":
        return ChartLineUp
      case "cash-flow":
        return Bank
      case "financial":
        return Bank
      case "trading":
        return ArrowsDownUp
      case "market":
        return ArrowsDownUp
      case "valuation":
        return MoneyWavy
      default:
        return is_gmv_metric ? Bank : TrendUp
    }
  } catch (error) {
    // Highly unlikely, but dont want to crash app just for an icon so why not.
    console.warn("Broken metric. Missing metrics filtering?", metric)
    return TrendUp
  }
}
